module.exports = __webpack_public_path__ + "img/800.57c732e7.png";